import styled from 'styled-components';
import { MAX_MOBILE_WIDTH } from '../../../../utils/constants';

export const ImageViewContainer = styled.div`
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: ${MAX_MOBILE_WIDTH}px) {
    flex-direction: column-reverse;
    height: 90vh;
  }
`;

export const ImageViewLeftSection = styled.div`
  display: flex;
  width: 10vw;
  height: 600px;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
  @media screen and (max-width: ${MAX_MOBILE_WIDTH}px) {
    flex-wrap: nowrap;
    flex-direction: row;
    height: auto;
    width: 95vw;
    overflow: auto;
    padding-left: 16px;
    padding-right: 16px;
  }
`;

export const ImageViewRightSection = styled.div`
  width: 600px;
  height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 100px;
  @media screen and (max-width: ${MAX_MOBILE_WIDTH}px) {
    height: 360px;
    width: 100vw;
  }
`;

export const ImageViewRightSectionImage = styled.img`
  width: ${(props) => props.imageDimensions?.width};
  height: ${(props) => props.imageDimensions?.height};
  object-fit: cover;
  @media screen and (max-width: ${MAX_MOBILE_WIDTH}px) {
    object-fit: fill;
    width: ${(props) => props.imageDimensions?.width};
    height: ${(props) =>
      props.isCustomWebsite ? props.imageDimensions?.height : 'unset'};
    aspect-ratio: ${(props) => (props.isCustomWebsite ? '' : '1/1')};
  }
`;

export const ImageViewRightSectionPrev = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  cursor: pointer;
  @media screen and (max-width: ${MAX_MOBILE_WIDTH}px) {
    position: absolute;
    left: 0;
    transform: translateY(-50%);
  }
`;
export const ImageViewRightSectionNext = styled.div`
  display: flex;
  align-items: center;
  margin-left: 20px;
  cursor: pointer;
  > svg {
    transform-box: fill-box;
    transform-origin: center;
    transform: rotate(180deg);
  }
  @media screen and (max-width: ${MAX_MOBILE_WIDTH}px) {
    position: absolute;
    right: 0%;
    transform: translateY(-50%);
  }
`;

export const CloseIcon = styled.div`
  display: flex;
  cursor: pointer;
  @media screen and (max-width: ${MAX_MOBILE_WIDTH}px) {
    margin-top: 18px;
    margin-left: 16px;
  }
`;

export const ImageContainerLeftSection = styled.div`
  display: flex;
  width: ${(props) => props.thumbnailImageDimensions?.width};
  height: ${(props) => props.thumbnailImageDimensions?.height};
  margin-bottom: 16px;
  ${(props) => (props?.borderColor ? 'border : 0.6px solid #858585' : '')};
  cursor: pointer;
  @media screen and (max-width: ${MAX_MOBILE_WIDTH}px) {
    margin-right: 14px;
    width: ${(props) => props.thumbnailImageDimensions?.width};
    height: ${(props) => props.thumbnailImageDimensions?.height};
    flex-shrink: 0;
  }
`;

export const ImageLeftSection = styled.img`
  width: ${(props) => props.thumbnailImageDimensions?.width};
  height: ${(props) => props.thumbnailImageDimensions?.height};
`;
